interface JSONCarrierAccountRegStatus {
  carrier_account: string;
  status: string;
}

enum RegStatus {
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
  OPTED_OUT = 'OPTED_OUT',
  PENDING_INFO = 'PENDING_INFO',
  PENDING_TERMS = 'PENDING_TERMS',
  PROCESSING = 'PROCESSING',
  UNDEFINED = 'UNDEFINED', // If an unexpected status is found fallback to UNDEFINED
}

type RegStatusByCarrierAccount = {
  [key: string]: RegStatus;
};

type IncompleteRegStatus = Exclude<RegStatus, RegStatus.COMPLETE>;

interface CarrierAccountRegStatus {
  carrierAccount: string;
  status: RegStatus;
}

const fromJSON = (jsonRegStatus: JSONCarrierAccountRegStatus) => {
  const serialized: CarrierAccountRegStatus = {
    carrierAccount: jsonRegStatus.carrier_account,
    status: RegStatus[jsonRegStatus.status as RegStatus] || RegStatus.UNDEFINED,
  };

  return serialized;
};

export default CarrierAccountRegStatus;
export {
  IncompleteRegStatus,
  JSONCarrierAccountRegStatus,
  RegStatus,
  RegStatusByCarrierAccount,
  fromJSON,
};
